import {
    MINI_PDP_ON_OPEN,
    MINI_PDP_ON_CLOSE,
    MINI_PDP_ON_MODE_CHANGE,
    SELECT_PRODUCT,
    MINI_PDP_PERSIST_ERROR,
    MINI_PDP_CLOSE_ERROR,
    MINI_PDP_OPEN_ERROR,
    MINI_PDP_ON_SHOP_THE_LOOK_OPEN,
    MINI_PDP_ON_SHOP_THE_LOOK_CLOSE,
} from '../actionTypes/MiniPDPActionTypes';
import { UPDATE_ITEM } from '../actionTypes/UpdateItemActionTypes';

export const updateItems = (payload) => ({
    type: UPDATE_ITEM,
    payload: {
        payload,
    },
});

export const miniPDPOnOpen = (payload) => ({
    type: MINI_PDP_ON_OPEN,
    payload,
});

export const miniPDPOnClose = () => ({
    type: MINI_PDP_ON_CLOSE,
});

export const miniPDPOnModeChange = (slide) => ({
    type: MINI_PDP_ON_MODE_CHANGE,
    payload: slide,
});

export const selectProduct = (payload) => ({
    type: SELECT_PRODUCT,
    payload,
});

export const persistError = () => ({
    type: MINI_PDP_PERSIST_ERROR,
});

export const miniPDPOpenError = () => ({
    type: MINI_PDP_OPEN_ERROR,
});

export const miniPDPCloseError = () => ({
    type: MINI_PDP_CLOSE_ERROR,
});

export const miniPDPOnShopTheLookOpen = () => ({
    type: MINI_PDP_ON_SHOP_THE_LOOK_OPEN,
});

export const miniPDPOnShopTheLookClose = () => ({
    type: MINI_PDP_ON_SHOP_THE_LOOK_CLOSE,
});
